import { render, staticRenderFns } from "./DataSelect.vue?vue&type=template&id=4f4da26a&scoped=true"
import script from "./DataSelect.vue?vue&type=script&lang=js"
export * from "./DataSelect.vue?vue&type=script&lang=js"
import style0 from "./DataSelect.vue?vue&type=style&index=0&id=4f4da26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4da26a",
  null
  
)

export default component.exports